import React from 'react';
import { ArrowLeft, ShieldCheck, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

export default function Legal() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button type="button" className="legal-back-button" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} />
          Voltar
        </button>

        <header className="legal-header">
          <h1 translate="no" className="notranslate">Política de Privacidade</h1>
          <p>
            Este conteudo explica como o CorreFood trata dados pessoais e quais sao as regras de uso da plataforma.
          </p>
        </header>

        <section id="politica-privacidade" className="legal-section" aria-label="Política de Privacidade">
          <h2>
            <ShieldCheck size={18} />
            <span translate="no" className="notranslate">Política de Privacidade</span>
          </h2>
          <div className="legal-card">
            <h3>1. Dados coletados</h3>
            <p>
              Coletamos dados de cadastro e uso da plataforma, como nome, e-mail, telefone, endereco, historico de pedidos
              e localizacao necessaria para entrega.
            </p>

            <h3>2. Uso dos dados</h3>
            <p>
              Os dados sao utilizados para autenticar usuarios, processar pedidos, organizar entregas, prevenir fraude,
              melhorar a experiencia e cumprir obrigacoes legais.
            </p>

            <h3>3. Compartilhamento</h3>
            <p>
              Informacoes essenciais do pedido podem ser compartilhadas com lojistas e motoboys para execucao da entrega.
              Nao vendemos dados pessoais.
            </p>

            <h3>4. Seguranca</h3>
            <p>
              Aplicamos controles tecnicos e operacionais para reduzir riscos de acesso indevido, alteracao e vazamento
              de dados.
            </p>

            <h3>5. Direitos do usuario</h3>
            <p>
              O usuario pode solicitar atualizacao ou exclusao de dados quando aplicavel, conforme a legislacao vigente.
            </p>
          </div>
        </section>

        <section id="termos-condicoes" className="legal-section" aria-label="Termos de Condições">
          <h2>
            <FileText size={18} />
            <span translate="no" className="notranslate">Termos de Condições</span>
          </h2>
          <div className="legal-card">
            <h3>1. Aceitacao</h3>
            <p>
              Ao usar o CorreFood, voce concorda com estes termos, com a politica de privacidade e com as regras
              especificas de cada funcionalidade.
            </p>

            <h3>2. Responsabilidades</h3>
            <p>
              Clientes devem informar dados corretos do pedido e endereco. Lojistas e motoboys devem operar com
              informacoes atualizadas e cumprimento das regras da plataforma.
            </p>

            <h3>3. Pedidos e pagamentos</h3>
            <p>
              Pedidos estao sujeitos a disponibilidade de produtos, confirmacao da loja e validacao de pagamento.
              Cancelamentos seguem as regras de cada estabelecimento.
            </p>

            <h3>4. Conduta e bloqueio</h3>
            <p>
              O uso indevido, fraude, abuso ou violacao das politicas pode gerar suspensao ou encerramento de conta.
            </p>

            <h3>5. Atualizacoes</h3>
            <p>
              Estes termos podem ser atualizados para refletir melhorias da plataforma ou exigencias legais. A versao
              mais recente prevalece.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
